import { deserialize } from 'cerialize';

export abstract class Entity {
  @deserialize
  public id: number;
}
